import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class PageElementResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/page_elements' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
